/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import BatchUpdateAbstract from 'cio/app-models/action-abstracts/batch-update';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import { BatchUpdateTemplateType } from 'cio/utils/actions/batch-update';
import DS from 'ember-data';

interface BatchUpdateEditSidebarEditorArgs {
  actionAbstract: BatchUpdateAbstract;
  isSaving: boolean;
  onSelect: () => unknown;
  onDeselect: () => unknown;
  hasReadOnlyPermission: boolean;
}
export default class BatchUpdateEditSidebarEditor extends Component<BatchUpdateEditSidebarEditorArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;

  BatchUpdateTemplateType = BatchUpdateTemplateType;

  get hasDetails() {
    let { actionAbstract } = this.args;
    let { action } = actionAbstract;

    if (action.templateType === BatchUpdateTemplateType.AttributeUpdate) {
      return actionAbstract.recipientConditions.length > 0 || actionAbstract.bodyRows.rows.length > 0;
    } else if (action.templateType === BatchUpdateTemplateType.CreateEvent) {
      return !isEmpty(action.eventName);
    }

    return false;
  }
}
